import type { Pcg32 } from '../engine';

/** Name parts for the Broker's world: small carved figures with pawnshop tags (Appendix A). */
const GIVEN = [
  'Ada',
  'Bram',
  'Cleo',
  'Dunstan',
  'Edda',
  'Fen',
  'Greta',
  'Hollis',
  'Ivo',
  'Juno',
  'Kestrel',
  'Lark',
  'Mabel',
  'Nell',
  'Otto',
  'Pim',
  'Quill',
  'Rook',
  'Sable',
  'Tamsin',
  'Ulla',
  'Vesper',
  'Wren',
  'Yarrow',
  'Zeb',
  'Alder',
  'Bettany',
  'Corvin',
  'Dorrit',
  'Esme',
  'Florin',
  'Gideon',
  'Hester',
  'Isolde',
  'Jory',
  'Linnet',
  'Mercer',
  'Oriel',
  'Perpetua',
  'Rowan',
  'Silas',
  'Thistle',
  'Umber',
  'Vale',
  'Wick',
] as const;

const EPITHETS = [
  'the Quiet',
  'the Bold',
  'Halfpenny',
  'Tallowhand',
  'of the Ledger',
  'Lamplight',
  'the Chipped',
  'Ashgrove',
  'the Patient',
  'Blackwood',
  'the Lucky',
  'Coldwater',
  'the Varnished',
  'Oakheart',
  'the Last',
  'Ticketless',
  'the Crooked',
  'Emberly',
  'the Unclaimed',
  'Moth',
  'the Redeemed',
  'Thimble',
  'the Lean',
  'Cinder',
  'the Borrowed',
  'Glasswell',
] as const;

/** Generates a name not already in `taken`, using the campaign stream. */
export function generateName(rng: Pcg32, taken: ReadonlySet<string>): string {
  // Prefer a given name nobody has yet, so board tags (first names) stay unambiguous.
  const usedGiven = new Set([...taken].map((n) => n.split(' ')[0]));
  const fresh = GIVEN.filter((g) => !usedGiven.has(g));
  const pool = fresh.length > 0 ? fresh : GIVEN;
  for (let attempt = 0; attempt < 200; attempt++) {
    const name = `${rng.pick(pool)} ${rng.pick(EPITHETS)}`;
    if (!taken.has(name)) return name;
  }
  // Practically unreachable (over a thousand combinations); fall back to a numbered name.
  const given = rng.pick(GIVEN);
  let n = taken.size + 1;
  while (taken.has(`${given} No. ${n}`)) n++;
  return `${given} No. ${n}`;
}
